import PageShell from '@/components/feature/PageShell';
import Seo from '@/components/base/Seo';
import Breadcrumbs from '@/components/base/Breadcrumbs';
import InsightExplorer from '@/pages/insight/components/InsightExplorer';
import { allArticles } from '@/lib/content';

export default function InsightPage() {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';

  const jsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: `${origin}/` },
        { '@type': 'ListItem', position: 2, name: '内幕观察', item: `${origin}/insight` },
      ],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: '内幕观察 - 职镜观察',
      description: '按主题整理的企业运营内幕、管理层背景、员工爆料、办公环境、裁员动向与薪资纠纷观察条目。',
      url: `${origin}/insight`,
      mainEntity: {
        '@type': 'ItemList',
        itemListElement: allArticles.map((article, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          name: article.title,
          url: `${origin}/insight/${article.id}`,
        })),
      },
    },
  ];

  return (
    <PageShell>
      <Seo
        title="内幕观察 | 运营内幕、员工爆料与裁员薪资线索整理 - 职镜观察"
        description="浏览职镜观察的全部内幕观察条目，可按运营内幕、老板背景、员工爆料、办公环境、裁员内幕与薪资纠纷六大主题筛选，支持关键词搜索与热度排序。"
        keywords="内幕观察,运营内幕,员工爆料,裁员内幕,薪资纠纷,职场信息"
        jsonLd={jsonLd}
      />
      <div className="border-b border-background-200 bg-background-100 paper-grain">
        <div className="mx-auto max-w-content px-4 pb-10 pt-8 md:px-6 md:pb-12 md:pt-10">
          <Breadcrumbs items={[{ name: '首页', path: '/' }, { name: '内幕观察' }]} />
          <p className="font-label text-xs tracking-[0.28em] text-primary-600">OBSERVATION ARCHIVE</p>
          <h1 className="mt-3 max-w-3xl font-heading text-2xl font-black leading-snug text-foreground-950 md:text-4xl">
            内幕观察：把公开线索整理成可以判断的依据
          </h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            这里汇集了全部观察条目。你可以用关键词直接搜索关心的公司与话题，也可以按主题筛选，
            按最新或最热排序，快速定位到与你处境最接近的那几条。
          </p>
        </div>
      </div>

      <div className="mx-auto max-w-content px-4 py-10 md:px-6 md:py-14">
        <InsightExplorer />
      </div>
    </PageShell>
  );
}